<template>
    <div class="content">
      <el-row class="bgW">
        <el-col :span="22">
          <!--检索条件-->
          <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
            
          </el-form>
        </el-col>
        <el-col :span="2" style="text-align: right">
          <!-- <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button> -->
        </el-col>
      </el-row>
  
      <el-row>
          <el-col :span="24">
            <el-table
              :data="list"
              size="small"
              border
              :cell-style="$style.cellStyle"
              :header-cell-style="$style.rowClass"
              @selection-change="handleSelectionChange"
            >
              <ElTableColumn label="星空单号">
                <template slot-scope="{ row }">
                  <span   @click="refundAmountDetail(row)" >
                    {{ row.king_num }}
                  </span>
                </template>
              </ElTableColumn>
              <ElTableColumn label="退货日期" prop="deal_time"  width="95" />

              <ElTableColumn label="客户名称">
                <template slot-scope="{ row }">
                  <span   @click="refundAmountDetail(row)" >
                    {{ row.customer_name }}
                  </span>
                </template>
              </ElTableColumn>

              <ElTableColumn label="客户K3代码" prop="king_no" width="95"  />
              <ElTableColumn label="退货门店" prop="shop_name" />
              <ElTableColumn label="操作人" prop="operator_name" />
              <ElTableColumn label="退货商品" prop="goods_name" />
              <ElTableColumn label="商品编码" prop="kingdee_code" />
              <ElTableColumn label="商品类型" prop="goods_type" />
              <ElTableColumn label="退货数量" prop="refund_num" />
              <ElTableColumn label="退货次数" prop="refund_service_num" />
              <ElTableColumn label="退货本金" prop="balance" />
              <ElTableColumn label="退货赠金" prop="gift" />
              <ElTableColumn label="退货店转" prop="store" />
              <ElTableColumn label="退款金额" prop="refund_amount_sum" />
              <ElTableColumn label="订单状态" prop="status_msg" />
            </el-table>
            <pagination
              class="page tc mt10"
              :total="page.total"
              :page.sync="page.page"
              :limit.sync="page.limit"
              @pagination="getList"
            />
          </el-col>
      </el-row>
            <!-- 卡项信息详情 --> 
      <el-dialog
        title="退款金额"
        :visible.sync="refundAmountDetailPop"
        width="75%"
      >
        <el-table
          :data="refundAmountDetailTable"
            border
            style="width: 100%">
            <el-table-column
              prop="pay_mode"
              label="支付方式"
              width="180">
            </el-table-column>
            <el-table-column
              prop="business_type"
              label="业务类型"
              width="180">
            </el-table-column>
            <el-table-column
              prop="refund_balance"
              label="退货本金"
              width="180">
            </el-table-column>
            <el-table-column
              prop="refund_gift"
              label="退货赠金">
            </el-table-column>
            <el-table-column
              prop="refund_store"
              label="退货店转">
            </el-table-column>
        </el-table>
      </el-dialog>
      </div>
  </template>
  
  <script>
  
  import { searchPersonList } from '@/api/staff'
  import { mapGetters } from "vuex";
  import dateMixin from '@/mixins/dateMixin';
  import pagination from "@/components/Pagination";
  import { refundGoodsOneList, refundGoodsOneAmountDetail,refundExport, lockOrderR } from "@/api/order";
  class Page {
    total = 0;
    page = 1;
    limit = 10;
  }
  class Search {
    refund_type = "";
     sale_id = "";
    status =  1;
    telephone = "";
    start_time = "";
    end_time = "";
    consignee = "";
    shop_name = "";
    low_total = "";
    large_total = "";
    business_type = "";
    order_type = "";
    display_cannel = 1;
  }
  class Options {
    staff=[];
    refund_type = [
      { id: '101.01', name: "退款店转" },
      { id: '101.02', name: "退款" }, 
      { id: '101.03', name: "退款调整" },
    ];
    refund_modeList = [
      { id: '01', name: "现金" },
      { id: '02', name: "刷卡/微信/支付宝" }, 
      { id: '03', name: "基本户收款" },
      { id: '04', name: "分期" },
      { id: '05', name: "平台收款" },
      { id: '06', name: "店转" },
    ];
    business_type = [
      { id: 1, name: "疤痕" },
      { id: 2, name: "项目" }
    ];
    order_type = [
      { id: 1, name: "新单" },
      { id: 2, name: "补单" }
    ];
    display_cannel = [
      // { id: 0, name: "不显示" },
      // { id: 1, name: "显示" }
      { id: 1, name: "未作废" },
      { id: 4, name: "已作废" }
    ];
  }
  export default {
    mixins: [dateMixin], 
    name: "OrderList",
    components: {
      pagination
    },
    props: {
      clienId: {
        type: String,
        default: ""
      },
      detail: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data() {
      return {
        fullscreenLoading: false,
        search: new Search(), // 检索条件
        options: new Options(), // 选项
        page: new Page(), // 分页
        list: [], // 数据展示
        idList: "",
        oldId:"",
        value1: [],
        sum_ben_amount: "noShow",
        refundAmountDetailPop:false,
        refundAmountDetailTable:[]
      };
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    mounted() {
      if(this.clienId){
        this.oldId = this.$route.query.id.toString()
      }else{
        this.setDefaultDate(); // 直接调用混入的方法
      }
       this.getOptions();
      this.getList();
    },
    methods: {

      refundAmountDetail(row){
        this.refundAmountDetailPop = true;
        console.log('打印1')
        refundGoodsOneAmountDetail({ order_id:row.id }).then(
          res => {
            console.log('打印'+res)
            this.refundAmountDetailTable = res.list
          }
        ).catch(err =>{
          console.log('打印2'+err)
        });
      },
      getOptions(){
        searchPersonList().then(
          res => {
            this.options.staff = res
          }
        )
      },
      // 获取列表
      getList(option) {
        if (option == "search") this.page = new Page();
        refundGoodsOneList({
          ...this.search,
          ...this.page,
          order_id: this.$route.query.order_id,
        }).then(res => {
          this.list = res.list;
          this.page.total = res.dataCount;
        });
      },
      // 日期搜索
      searchTime(val) {
        if (val) {
          this.search.start_time = val[0];
          this.search.end_time = val[1];
        } else {
          this.search.start_time = "";
          this.search.end_time = "";
        }
      },
      // 点击详情
      tapBtn(type, row) {
        switch (type) {
          case "退款详情":
            this.$router.push(
              "./refundDetail?id=" + row.id + "&type=" + row.type
            );
            break;
          case "客户退款详情":
            const queryT = {
              id: row.id,
              activeName: "second1",
              activeTab: "refundList",
              clienId: this.clienId,
              type: row.type,
              detail: this.detail
            };
            this.$router.push({ name: "退/收单详情", query: queryT });
            break;
          case "money":
            const query = { detail: this.detail };
            this.$router.push({ name: "添加退款订单", query });
            break;
          case "export":
            this.hint("导出选中列表", "export");
            break;
          case "lock":
            if (this.search.end_time) {
              this.hint("锁定选中条件的订单", "lock");
            } else {
              this.$message({
                message: "请选择锁定日期",
                type: "warning"
              });
            }
            break;
        }
      },
      // 提示
      hint(text, type) {
        this.$confirm(`${text},是否确定？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            if (type == "export") {
              this.getExport();
            } else {
              this.getLockOrder();
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      },
      //锁单
      getLockOrder() {
        lockOrderR({ ...this.search, type: 1 }).then(res => {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.getList();
        });
      },
      // 导出
      getExport() {
        this.fullscreenLoading = true
        refundExport({
        ...this.search,
        type: 1,
        uid: this.clienId ? this.clienId : "",
        }).then(res=>{
          window.open(res.data.url);
          this.fullscreenLoading = false
        })
        // refundExport({ id: this.idList, type: 1 }).then(res => {
        //   window.open(res.data.url);
        // });
      },
  
      // 改变表格选中状态
      handleSelectionChange(val) {
        this.idList = val.map(i => {
          return i.id;
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .accountCon {
    background: #fff;
    padding: 10px 0px 80px;
    .btnBox {
      display: flex;
      column-gap: 10px;  
    }
  }
  .reveal {
    text-align: right;
    padding: 20px 0;
    .peril {
      font-weight: bold;
    }
  }
  </style>
  